"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findSectionsAndCookbookIdsForRecipeQuery = exports.getSectionAndCookbookIdForRecipeQuery = void 0;
const client_1 = require("@apollo/client");
exports.getSectionAndCookbookIdForRecipeQuery = client_1.gql `
  query GetSectionAndCookbookIdForRecipe($recipeId: String!) {
    getSectionAndCookbookIdForRecipe(recipeId: $recipeId) {
      sectionId
      cookbookId
    }
  }
`;
exports.findSectionsAndCookbookIdsForRecipeQuery = client_1.gql `
  query FindSectionsAndCookbookIdsForRecipe($recipeId: String!) {
    findSectionsAndCookbookIdsForRecipe(recipeId: $recipeId) {
      sectionId
      cookbookId
    }
  }
`;
//# sourceMappingURL=getSectionAndCookbookIdForRecipe.js.map